import React from "react"
import { useTranslation } from "react-i18next"
import { Link } from "react-router-dom"

import CustomDatePicker from "../../../components/Common/Form/DatePicker"
import { ErrorField } from "../../../components/Common/Form/Error"
import { InputBox } from "../../../components/Common/Form/InputBox/InputBox"
import { TextAreaBox } from "../../../components/Common/Form/TextAreaBox"
import Table from "../../../components/Tables"
import { propsToFormDate } from "../../../components/Utility/DateFormate"

const ClaimForm=({
    errors,
    formData,
    claimParts,
    columns,
    onChangeHandler,
    onClickAddPart,
    onFormSubmitHandler,
    onDateHandler,
    permission,
    totalCredit,
    totalDebit
})=>{
    const { t } = useTranslation()
    const DORProps = propsToFormDate(new Date()) //Date of request props

    return(
        <div className="flex flex-col bg-white py-4 rounded-lg gap-4 border border-secondary-300">
            <h1 className="flex items-center text-2xl text-primary-50 font-black p-4"> { t("ClaimForm.SROClaimFormHeading") }</h1>
            <div className="w-full bg-lightSkyblue p-4 ">
                <div className="flex flex-row justify-between text-base text-secondary-50">
                    <div>
                        <span>{ `${t("ClaimForm.dateOfRequest")}:` }</span>
                        <span className="font-semibold">{ ` ${DORProps?.day}/${DORProps?.month}/${DORProps?.year}` }</span>
                    </div>
                    <div>
                        <span>{ `${t("ClaimForm.mailFormTo")}:` }</span>
                        <span className="font-semibold">{ ` ${formData?.mail_form_to}` }</span>
                    </div>
                </div>
                <div className="flex flex-row justify-between text-base text-secondary-50">
                    <div className="w-full flex space-between gap-4 mb-4 mt-4">
                        <div className="w-1/4 relative">
                            <InputBox
                                label={ t("ClaimForm.requesterName") }
                                id="requester_name"
                                type="text"
                                name="requester_name"
                                value={ formData?.requester_name }
                                errors={ errors }
                                defaultValue={ "" }
                                isRequired={ true }
                                maxLength="50"
                                isComponentLabelValidation={ true }
                                onChangeHandler={ (e) => onChangeHandler(e) }
                            />
                            { /* <ErrorField name={ errors?.requester_name } /> */ }
                        </div>
                        <div className="w-1/4 relative">
                            <InputBox
                                label={ t("ClaimForm.requesterEmail") }
                                id="requester_email"
                                type="text"
                                name="requester_email"
                                value={ formData?.requester_email }
                                errors={ errors }
                                defaultValue={ "" }
                                isRequired={ true }
                                maxLength="50"
                                isComponentLabelValidation={ false }
                                onChangeHandler={ (e) => onChangeHandler(e) }
                            />
                            <ErrorField name={ errors?.requester_email } />
                        </div>
                        <div className="w-1/4 relative">
                            <InputBox
                                label={ t("ClaimForm.SROManager") }
                                id="sro_manager"
                                type="text"
                                name="sro_manager"
                                value={ formData?.sro_manager }
                                errors={ errors }
                                defaultValue={ "" }
                                isRequired={ false }
                                maxLength="50"
                                isComponentLabelValidation={ false }
                                onChangeHandler={ (e) => onChangeHandler(e) }
                            />
                            <ErrorField name={ errors?.sro_manager } />
                        </div>
                        <div className="w-1/4 relative">
                        </div>
                    </div>
                </div>
            </div>
            <div className="w-full p-4 border-b border-lightGray">
                <h1 className="flex items-center text-2xl text-primary-50 font-black"> { t("ClaimForm.customerDetail") }</h1>
                <div className="flex flex-row justify-between text-base text-secondary-50">
                    <div className="w-full flex space-between gap-4 mb-4 mt-4">
                        <div className="w-1/4 relative">
                            <InputBox
                                label={ t("ClaimForm.customerName") }
                                id="customer_name"
                                type="text"
                                name="customer_name"
                                value={ formData?.customer_name }
                                errors={ errors }
                                defaultValue={ "" }
                                isRequired={ true }
                                maxLength="50"
                                isComponentLabelValidation={ true }
                                onChangeHandler={ (e) => onChangeHandler(e) }
                                disabled={ true  }
                            />
                        </div>
                        <div className="w-1/4 relative">
                            <InputBox
                                label={ t("ClaimForm.soldToNo") }
                                id="sold_to_no"
                                type="text"
                                name="sold_to_no"
                                value={ formData?.sold_to_no }
                                errors={ errors }
                                defaultValue={ "" }
                                isRequired={ false }
                                maxLength="50"
                                isComponentLabelValidation={ false }
                                onChangeHandler={ (e) => onChangeHandler(e) }
                                disabled={ true  }
                            />
                            <ErrorField name={ errors?.sold_to_no } />
                        </div>
                        <div className="w-1/4 relative">
                            <InputBox
                                label={ t("ClaimForm.shipToNo") }
                                id="ship_to_no"
                                type="text"
                                name="ship_to_no"
                                value={ formData?.ship_to_no }
                                errors={ errors }
                                defaultValue={ "" }
                                isRequired={ false }
                                maxLength="50"
                                isComponentLabelValidation={ false }
                                onChangeHandler={ (e) => onChangeHandler(e) }
                                disabled={ true  }
                            />
                            <ErrorField name={ errors?.ship_to_no } />
                        </div>
                        <div className="w-1/4 relative">
                        </div>
                    </div>
                </div>
            </div>
            <div className="w-full p-4 border-b border-lightGray ">
                <h1 className="flex items-center text-2xl text-primary-50 font-black"> { t("ClaimForm.orderDetail") }</h1>
                <div className="flex flex-row justify-between text-base text-secondary-50">
                    <div className="w-full flex space-between gap-4 mb-4 mt-4">
                        <div className="w-1/4 relative">
                            <InputBox
                                label={ t("ClaimForm.originalInvoiceNo") }
                                id="original_invoice_no"
                                type="text"
                                name="original_invoice_no"
                                value={ formData?.original_invoice_no }
                                errors={ errors }
                                defaultValue={ "" }
                                isRequired={ true }
                                maxLength="50"
                                isComponentLabelValidation={ true }
                                onChangeHandler={ (e) => onChangeHandler(e) }
                            />
                        </div>
                        <div className="w-1/4 relative">
                            <InputBox
                                label={ t("ClaimForm.salesOrder") }
                                id="sales_order"
                                type="text"
                                name="sales_order"
                                value={ formData?.sales_order }
                                errors={ errors }
                                defaultValue={ "" }
                                isRequired={ true }
                                maxLength="50"
                                isComponentLabelValidation={ true }
                                onChangeHandler={ (e) => onChangeHandler(e) }
                            />
                        </div>
                        <div className="w-1/4 relative">
                            <InputBox
                                label={ t("ClaimForm.yourRef") }
                                id="reference"
                                type="text"
                                name="reference"
                                value={ formData?.reference }
                                errors={ errors }
                                defaultValue={ "" }
                                isRequired={ true }
                                maxLength="50"
                                isComponentLabelValidation={ false }
                                onChangeHandler={ (e) => onChangeHandler(e) }
                                disabled={ true }
                            />
                            <ErrorField name={ errors?.reference } />
                        </div>
                        <div className="w-1/4 relative">
                            <CustomDatePicker
                                className=""
                                selected={ formData?.invoice_date || "" }
                                placeHolder={ t("ClaimForm.invoiceDate") }
                                value={ formData?.invoice_date || "" }
                                id="invoice_date"
                                name="invoice_date"
                                onChangehandler={ onDateHandler }
                                isFutureDateDisabled={ true }
                                isPastDateDisabled={ true }
                                isComponentLabelValidation={ true }
                                errorData={ errors }
                                isRequired={ true }
                            />
                        </div>
                    </div>
                </div>
                <div className="flex flex-row justify-between text-base text-secondary-50">
                    <div className="w-full flex space-between gap-4 mb-4 ">
                        <div className="w-1/4 relative">
                            <InputBox
                                label={ t("ClaimForm.inVoiceCurrency") }
                                id="invoice_currency"
                                type="text"
                                name="invoice_currency"
                                value={ formData?.invoice_currency }
                                errors={ errors }
                                defaultValue={ "" }
                                isRequired={ false }
                                maxLength="50"
                                isComponentLabelValidation={ false }
                                onChangeHandler={ (e) => onChangeHandler(e) }
                                disabled={ true }
                            />
                            <ErrorField name={ errors?.invoice_currency } />
                        </div>
                        <div className="w-1/4 relative">
                            <InputBox
                                label={ t("ClaimForm.shipmentNo") }
                                id="shipment_no"
                                type="text"
                                name="shipment_no"
                                value={ formData?.shipment_no }
                                errors={ errors }
                                defaultValue={ "" }
                                isRequired={ true }
                                maxLength="50"
                                isComponentLabelValidation={ true }
                                onChangeHandler={ (e) => onChangeHandler(e) }
                            />
                        </div>
                        <div className="w-1/2 relative">
                            <InputBox
                                label={ t("ClaimForm.deliveryFromPackingList") }
                                id="delivery_from_packing_list"
                                type="text"
                                name="delivery_from_packing_list"
                                value={ formData?.delivery_from_packing_list }
                                errors={ errors }
                                defaultValue={ "" }
                                isRequired={ false }
                                maxLength="50"
                                isComponentLabelValidation={ false }
                                onChangeHandler={ (e) => onChangeHandler(e) }
                            />
                            <ErrorField name={ errors?.delivery_from_packing_list } />
                        </div>
                        <div className="">
                        </div>
                    </div>
                </div>
            </div>
            <Table
                columns={ columns }
                data={ claimParts }
                editableRowId={ 1 }
                isCustomSearch={ false }
                isFullTableEdit={ true }
                disableSearch={ true }
                hideOverFlowAuto = { true }
            />
            <div className="p-4">
                <Link
                    onClick={ () => onClickAddPart() }
                    className="text-primary-100 text-sm font-lighter underline"
                >
                    { `+${t("ClaimForm.addPart")}` }
                </Link>
            </div>
            <div className="bg-lighestgray">
                <div className="flex flex-row justify-between text-base text-secondary-50 my-4">
                    <div className="w-5/6 flex flex-row justify-end  relative">
                        { t("ClaimForm.totalDebit") }
                    </div>
                    <div className="w-1/6 flex flex-row justify-end  relative mr-4">
                        { totalDebit }
                    </div> 
                </div>
                <div className="flex flex-row justify-between text-base text-secondary-50 my-4">
                    <div className="w-5/6 flex flex-row justify-end  relative">
                        { t("ClaimForm.totalCredit") }
                    </div>
                    <div className="w-1/6 flex flex-row justify-end  relative mr-4">
                        { totalCredit }
                    </div> 
                </div>
            </div>
            <div className="flex flex-row text-base text-secondary-50 p-4">
                <div className="w-2/5 mb-4">
                    <TextAreaBox
                        label={ t("ClaimForm.remarks") }
                        id="remarks"
                        data-test-id="remarks"
                        type="text"
                        name="remarks"
                        defaultValue={ "" }
                        value={ formData?.remarks }
                        errors={ errors }                      
                        isRequired={ false }
                        row={ 4 }                     
                        isComponentLabelValidation ={ false }
                        onChangeHandler={ (e) => onChangeHandler(e) }
                        rows="4"
                        maxLength="1000"
                    />
                    <span className="float-right text-secondary-50 mt-1">{ formData?.remarks.length }/1000 </span>
                </div>
            </div>
            <div className="flex flex-row justify-end p-4">
                <div>
                
                    <button
                        type="button"
                        onClick={ onFormSubmitHandler }
                        disabled={ permission?._write ? false : true }
                        className={ "rounded-full w-full font-bold text-sm hover:bg-primary-150 hover:text-primary-50 h-9 px-4 bg-primary-100 text-white" }
                    >
                        { t("ClaimForm.sendClaimForm")  }
                    </button>
                </div>
            </div>
        </div>
    )
}

export default ClaimForm
